// Organization list sort shared by the developer organization pickers.
const SORT_KEY = 'developerOrgSort';

// When the org was created, in ms: createdAt (signup) or metadata.createdAt (developer console),
// a Timestamp ({_seconds} over JSON); else the time in an org_<ms> id. Orgs with none sort last.
export function orgCreatedMs(org) {
  const created = org?.createdAt || org?.metadata?.createdAt;
  const seconds = created?._seconds ?? created?.seconds;
  if (typeof seconds === 'number') return seconds * 1000;
  if (created) {
    const parsed = Date.parse(created);
    if (!Number.isNaN(parsed)) return parsed;
  }
  const fromId = /^org_(\d{13})(?:_|$)/.exec(org?.id || '');
  return fromId ? Number(fromId[1]) : 0;
}

export function readOrgSort() {
  try { return localStorage.getItem(SORT_KEY) === 'newest' ? 'newest' : 'name'; } catch { return 'name'; }
}

export function saveOrgSort(mode) {
  try { localStorage.setItem(SORT_KEY, mode); } catch { /* not remembered */ }
}
